var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7441 0.978027C2.37682 0.978027 0.452148 2.24784 0.452148 4.73348V27.2662C0.452148 29.7518 2.37682 31.0217 4.7441 31.0217H26.2038C28.5711 31.0217 30.4958 29.7518 30.4958 27.2662V4.73348C30.4958 2.24784 28.5711 0.978027 26.2038 0.978027H4.7441ZM24.6681 6.14178L17.7071 14.493L25.8953 25.8579H19.4842L14.468 18.9643L8.72085 25.8579H5.53542L12.9793 16.9223L5.12635 6.14178H11.6984L16.2385 12.4439L21.4827 6.14178H24.6681ZM22.1332 23.8581L10.7394 8.03593H8.84156L20.3628 23.8581H22.1265H22.1332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.983a81e2adced1ee4fd7d5106f45f85a.svg";
export { ForwardRef as ReactComponent };